import { createPortal } from "react-dom";
import { useState } from "react";
import "../styles/OpenModel.css"

export default function OpenModal({ patient, onClose }) {
  const [showInfo, setShowInfo] = useState(true);
  return createPortal(
    <div className="modal-overlay" onClick={onClose}>
      <div className="simple-modal" onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <h2>Study Table setting</h2>
        <p className="subtitle">
          Setting to customize study table interface
        </p>
        {/* Body */}
        <div className="form-section">
          <label>Path to download folder to open cases in Radiant</label>
          <input
            type="text"
            placeholder="C:\Users\John\Downloads"
          />
        </div>
        <div className="form-section">
          <label>Color of studies which not reported</label>
          <select>
            <option>NONE</option>
          </select>
        </div>
        <div className="form-section">
          <label>Color of urgent studies</label>
          <select>
            <option>NONE</option>
          </select>
        </div>
        <div className="form-section">
          <label>Color of assigned studies</label>
          <select>
            <option>NONE</option>
          </select>
        </div>
        <div className="form-section">
          <label>Color of locked studies</label>
          <select>
            <option>NONE</option>
          </select>
        </div>
        <div className="form-section">
          <label>Color of signed off studies</label>
          <select>
            <option>NONE</option>
          </select>
        </div>
        {/* Submit */}
        <button className="submit-btn">SUBMIT</button>
        {/* Footer */}
        <div className="simple-modal-footer">
          <button className="close-btn" onClick={onClose}>
            CLOSE
          </button>
        </div>
        {/*  Info Popup (center wala) */}
        {showInfo && (
          <div className="info-modal">
            <h3>Info</h3>
            <p>
              Please add path to download folder in Study Table setting
            </p>
            <button onClick={() => setShowInfo(false)}>
              CLOSE
            </button>
          </div>
        )}
      </div>
    </div>,
    document.body
  );
}